import React from 'react';

/**
 * @interface PrpNoSearchResultsProps
 */
export interface PrpNoSearchResultsProps {
  noResult: {
    heading: string;
    text: string;
    buttonText: string;
  };
}

const PrpNoSearchResults = ({ noResult }: PrpNoSearchResultsProps) => {
  const onButtonClick = () => {
    const saytInputClassName = '.aa-Input';
    const saytInputElement = document.querySelector<HTMLInputElement>(saytInputClassName);
    if (saytInputElement) {
      saytInputElement.focus();
    }
  };

  return (
    <section className="tsc-container--v2">
      <div className="prp-no-search-results">
        <div className="prp-no-search-results__icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="43"
            height="44"
            viewBox="0 0 43 44"
          >
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
              <g fill="#000" fillRule="nonzero" transform="translate(-578 -55)">
                <g transform="translate(0 .418)">
                  <g transform="translate(290 55)">
                    <path
                      d="M41.31 13.132a21.437 21.437 0 00-4.608-6.835A21.44 21.44 0 0021.5 0 21.44 21.44 0 006.297 6.297 21.432 21.432 0 000 21.5a21.44 21.44 0 006.297 15.203A21.43 21.43 0 0021.5 43a21.445 21.445 0 0015.203-6.297A21.435 21.435 0 0043 21.5a21.36 21.36 0 00-1.69-8.368zM21.5 36.284a2.934 2.934 0 01-2.93-2.93 2.934 2.934 0 012.93-2.93 2.934 2.934 0 012.93 2.93 2.934 2.934 0 01-2.93 2.93zm2.93-9.776a.533.533 0 01-.532.532h-4.796a.533.533 0 01-.532-.532V7.249c0-.294.239-.533.532-.533h4.795c.294 0 .533.239.533.533v19.259z"
                      transform="translate(288)"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div className="prp-no-search-results__copy">
          <div className="prp-no-search-results__copy__heading">
            <h1 className="prp-no-search-results__copy__heading__self">{noResult.heading}</h1>
          </div>
          <div className="prp-no-search-results__copy__text">
            <p className="prp-no-search-results__copy__text__self">{noResult.text}</p>
            <button className="prp-no-search-results__copy__link" onClick={onButtonClick}>
              <span className="prp-no-search-results__copy__link__self">{noResult.buttonText}</span>
            </button>
          </div>
        </div>
      </div>
      {/* <div className="prp-no-search-results__footer">
        <span className="prp-no-search-results__footer__did-you-mean">Did you mean {'"'} boogie {'"'}?</span>
        <a className="prp-no-search-results__footer__other-results" href="#">View 50 search results</a>
      </div> */}
    </section>
  );
};

export default PrpNoSearchResults;
